import { all } from 'redux-saga/effects';

import authSaga from 'store/auth/saga';
import patientSaga from 'store/patient/saga';
import organisationSaga from 'store/organisation/saga';
import positionSaga from 'store/position/saga';
import staffSaga from 'store/staff/saga';
import roleSaga from 'store/role/saga';
import packageSaga from 'store/package/saga';
import bookingSaga from 'store/booking/saga';
import paperworkSaga from 'store/paperwork/saga';
import preferredSiteSaga from 'store/preferred_site/saga';
import addressBookSaga from 'store/address_book/saga';
import caseSaga from 'store/case/saga';
import projectIdentificationSaga from 'store/project_identification/saga';
import onsiteBookingSaga from 'store/onsite_booking/saga';
import bookingAMC360Saga from 'store/booking_amc360/saga';
import fittestBookingSaga from 'store/fittest_booking/saga';
import consultationSaga from 'store/consultation/saga';
import manageLoginSaga from 'store/manage_login/saga';
import utilSaga from 'store/util/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    patientSaga(),
    organisationSaga(),
    staffSaga(),
    roleSaga(),
    positionSaga(),
    packageSaga(),
    bookingSaga(),
    paperworkSaga(),
    preferredSiteSaga(),
    addressBookSaga(),
    caseSaga(),
    projectIdentificationSaga(),
    onsiteBookingSaga(),
    bookingAMC360Saga(),
    fittestBookingSaga(),
    consultationSaga(),
    manageLoginSaga(),
    utilSaga(),
  ]);
}
